import { Link, Outlet, useLocation } from "react-router-dom";
import { BookOpen, CalendarCheck, Cloud, Tags, Users } from "lucide-react";

export default function AdminPage() {
  const loc = useLocation();
  const tab = loc.pathname.endsWith("/videos")
    ? "videos"
    : loc.pathname.endsWith("/categories")
      ? "categories"
      : loc.pathname.endsWith("/checkins")
        ? "checkins"
        : loc.pathname.endsWith("/vod-import")
          ? "vod-import"
          : "users";

  return (
    <main className="container-narrow py-10">
      <div className="mb-8">
        <div className="badge mb-2">管理后台</div>
        <h1 className="font-display text-3xl font-semibold text-ink-900">系统管理</h1>
        <p className="mt-1 text-sm text-ink-400">
          仅管理员可见。新增/删除用户、维护分类与视频。
        </p>
      </div>

      <div className="flex gap-1 border-b border-surface-border">
        <Link
          to="/admin"
          className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
            tab === "users"
              ? "border-brand text-brand"
              : "border-transparent text-ink-400 hover:text-ink-600"
          }`}
        >
          <Users className="mr-1 inline h-4 w-4" /> 用户
        </Link>
        <Link
          to="/admin/categories"
          className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
            tab === "categories"
              ? "border-brand text-brand"
              : "border-transparent text-ink-400 hover:text-ink-600"
          }`}
        >
          <Tags className="mr-1 inline h-4 w-4" /> 分类
        </Link>
        <Link
          to="/admin/videos"
          className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
            tab === "videos"
              ? "border-brand text-brand"
              : "border-transparent text-ink-400 hover:text-ink-600"
          }`}
        >
          <BookOpen className="mr-1 inline h-4 w-4" /> 视频
        </Link>
        <Link
          to="/admin/checkins"
          className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
            tab === "checkins"
              ? "border-brand text-brand"
              : "border-transparent text-ink-400 hover:text-ink-600"
          }`}
        >
          <CalendarCheck className="mr-1 inline h-4 w-4" /> 打卡记录
        </Link>
        <Link
          to="/admin/vod-import"
          className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
            tab === "vod-import"
              ? "border-brand text-brand"
              : "border-transparent text-ink-400 hover:text-ink-600"
          }`}
        >
          <Cloud className="mr-1 inline h-4 w-4" /> 从腾讯 VOD 导入
        </Link>
      </div>

      <div className="mt-6">
        <Outlet />
      </div>
    </main>
  );
}
